module.exports = __webpack_public_path__ + "img/formal-check.c725e221.png";